// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_eb7ae5', '__Inter_Fallback_eb7ae5'","fontStyle":"normal"},"className":"__className_eb7ae5","variable":"__variable_eb7ae5"};